import React from 'react';
import { FaLink, FaUnlink } from 'react-icons/fa';
import styles from './styles/AssociateButton.module.css';
import i18n from '../../../i18n';

type NodeId = string;
type NodeHandler = (nodeId: NodeId) => void;

interface AssociateButtonProps {
  nodeId: NodeId;
  isAssociated: boolean;
  onAssociateToggle: NodeHandler;
  disabled?: boolean;
}

// Define a custom icon component type that accepts SVG props plus an optional title.
type IconComponent = React.FC<React.SVGProps<SVGSVGElement> & { title?: string }>;

const ValidatedFaLink = FaLink as unknown as IconComponent;
const ValidatedFaUnlink = FaUnlink as unknown as IconComponent;

const AssociateButton: React.FC<AssociateButtonProps> = ({
  nodeId,
  isAssociated,
  onAssociateToggle,
  disabled = false,
}) => {
  return (
    <div className={styles.associateButtonContainer}>
      <button
        className={`${styles.associateButton} ${isAssociated ? styles.associated : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) {
            onAssociateToggle(nodeId);
          }
        }}
        aria-label="Associate Node"
        disabled={disabled}
      >
        {isAssociated ? (
          <ValidatedFaLink aria-hidden="true" title={i18n.t("Associated")} />
        ) : (
          <ValidatedFaUnlink aria-hidden="true" title={i18n.t("Not Associated")} />
        )}
      </button>
    </div>
  );
};

export default AssociateButton;
